var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[_c('div',{staticStyle:{"width":"100%","height":"70vh"},attrs:{"id":"map"}}),_c('button',{staticClass:"fullscreen-btn",on:{"click":_vm.toggleFullScreen}},[_vm._v(" ⛶ Full Screen ")])])}
var staticRenderFns = []

export { render, staticRenderFns }